import { NL } from "./nl_NL"

/**
 * Type representing all valid internationalization keys
 */
export type IntlKey = keyof typeof NL

export const isIntlKey = (key: unknown): key is IntlKey => typeof key === "string" && key in NL
